import { gql } from '@apollo/client';
import userEventParticipationInfoCalendarViewFragment from '../userEventParticipationInfoCalendarViewFragment';

const DELETE_UNAVAILABLE_PERIOD = gql`
  mutation DeleteUnavailablePeriod($id: Int!, $targetUser: Int) {
    deleteUnavailablePeriod(id: $id, targetUser: $targetUser) {
      DeletedUnavailablePeriod
      AppraiserEvent {
        Id
        TargetUserEventParticipationInfo(targetUserId: $targetUser) {
          ...UserEventParticipationInfoFields
        }
      }
    }
  }

  ${userEventParticipationInfoCalendarViewFragment}
`;

export default DELETE_UNAVAILABLE_PERIOD;
